import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../Components/Header";
import Pagetitle from "../Components/Pagetitle";
import Footer from "../Components/Footer";
import { getData } from "../Api";

const MyOrders = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser && storedUser.phone) {
      setUser(storedUser);
      fetchOrders(storedUser.phone);
    } else {
      navigate("/login");
    }
  }, [navigate]);

  const fetchOrders = async (phone) => {
    try {
      const response = await getData(`/my-orders/${phone}`);
      if (response.success) {
        const normalizedOrders = response.data.map((order) => ({
          ...order,
          items:
            typeof order.items === "string"
              ? JSON.parse(order.items)
              : order.items,
        }));
        setOrders(normalizedOrders);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (order) => {
    navigate(`/orders/${order.order_id}`);
  };

  if (!user) return null;

  return (
    <main className="container-fluid">
      <Header />
      <Pagetitle />
      <div className="container my-5">
        <h2 className="text-center mb-4">My Orders</h2>

        {loading ? (
          <p className="text-center">Loading orders...</p>
        ) : orders.length === 0 ? (
          <p className="text-center">No orders found.</p>
        ) : (
          orders.map((order) => (
            <div className="card mb-3" key={order.id}>
              <div className="row g-0 py-3 align-items-center">
                <div className="col-md-3 text-center">
                  <img
                    src={order.items?.[0]?.image}
                    className="img-fluid rounded"
                    alt="Product"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div className="col-md-5">
                  <div className="card-body">
                    <h5 className="card-title mb-2">
                      Order ID: {order.order_id}
                    </h5>
                    <p className="card-text mb-1">
                      <strong>Name:</strong> {order.name}
                    </p>
                    <p className="card-text mb-1">
                      <strong>Phone:</strong> {order.phone}
                    </p>
                    <p className="card-text mb-1">
                      <strong>Address:</strong> {order.address}, {order.city}, {order.state}
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card-body">
                    <p className="card-text mb-1">
                      <strong>Payment:</strong> {order.paymentMethod}
                    </p>
                    <p className="card-text mb-1">
                      <strong>Total:</strong> ₹{order.total}
                    </p>
                    <p className="card-text mb-3">
                      <strong>Status:</strong>{" "}
                      <span
                        className={`badge bg-${
                          order.status === "shipped" ? "success" : "warning"
                        } text-uppercase`}
                      >
                        {order.status}
                      </span>
                    </p>
                    <button
                      className="btn-style1 btn-sm"
                      onClick={() => handleViewDetails(order)}
                    >
                      View All
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      <Footer />
    </main>
  );
};

export default MyOrders;